<template>
    <div class="about page flex flex-column skoda-pro-font">
        <NavControl :route="true"/>
        <div class="grid flex-grow mb-footer">
            <div class="side-about column collapse-right">
                <div>
                    <div class="flex">
                        <div class="flex flex-column flex-auto">
                            <div class="type flex-grow m-1 bg-green-light p-4 relative">
                                <h1 class="mb-headline pr-headline fs-35 mb-footer">{{ getItem().headline }}</h1>
                                <p class="fs-24 line-height"><strong>{{ getItem().mainDescription }}</strong></p>
                                <p class="fs-16 line-height text-medium-gray">{{ getItem().description }}</p>
                                <img :src="getIcon()" alt="" class="absolute-top-corner">
                            </div>
                            <div class="key-success border-green m-1 p-4 ">
                                <h2 class="mb-4 mt-0">Key success</h2>
                                <ul class="m-0 list-style-square pb-success line-height fs-16">
                                    <li class="text-green"><span class="text-white">Car of the year.</span></li>
                                    <li class="text-green"><span class="text-white">Design prices.</span></li>
                                    <li class="text-green"><span class="text-white">Timeless design.</span></li>
                                </ul>
                            </div>
                        </div>
                        <div class="flex flex-column border-green m-1 key-benefits">
                            <h3 class="fs-24 mb-4 mt-0">Key brand benefits</h3>
                            <div class="key-benefit">
                                <img src="./../assets/icons/cpu.png" alt="">
                                <p class="m-1">Partial autonomous management</p>
                            </div>
                            <div class="key-benefit wifi">
                                <img src="./../assets/icons/wifi.png" alt="">
                                <p class="m-1">Connectivity, connection with internetem, Wi-Fi hotspot</p>
                            </div>
                            <div class="key-benefit">
                                <img src="./../assets/icons/lak.png" alt="">
                                <p class="m-1">Laurin & Klement</p>
                            </div>
                            <div class="key-benefit">
                                <img src="./../assets/icons/cubism.png" alt="">
                                <p class="m-1">Crystalic design, cubism</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-about column collapse-right collapse-left">
                <div class="grid">
                    <div class="half column collapse-right">
                        <h2 class="mb-4">Recommended models</h2>
                        <div class="box-wrapper">
                            <div class="box model-box">
                                <div class="box-content" v-html="getCar(0)">
                                </div>
                                <div class="perspective"></div>
                            </div>
                            <div class="box model-box">
                                <div class="box-content" v-html="getCar(1)">
                                </div>
                                <div class="perspective"></div>
                            </div>
                        </div>
                    </div>
                    <div class="half column collapse-right">
                        <h2 class="mb-4">Additional models</h2>
                        <div class="box-wrapper">
                            <div class="box model-box additional">
                                <div class="box-content" v-html="getCar(2)">
                                </div>
                                <div class="perspective"></div>
                            </div>
                            <div class="box model-box additional">
                                <div class="box-content" v-html="getCar(3)">
                                </div>
                                <div class="perspective"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="full column">
                        <div class="box-wrapper m-10">
                            <div class="box key-feature">
                                <div class="box-content p-6">
                                    <h3>Key features</h3>
                                    <ul>
                                        <li v-for="feature in getKeyFeatures()" v-html="feature"></li>
                                    </ul>
                                </div>
                                <div class="perspective"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <img src="./../assets/skoda-logo.png" alt="">
            <div class="button-wrapper">
                <router-link class="button reset"
                             :to="{name: 'home'}">
                    Return to SST
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import NavControl from '@/components/nav-control.vue';

    export default {
        name: 'about',
        components: {
            NavControl,
        },
        methods: {
            getItem() {
                if (this.$route.params.data) {
                    return this.type[this.$route.params.data.mainFeatures[0].type];
                } else {
                    return '';
                }
            },

            getIcon() {
                if (this.$route.params.data) {
                    return require(`./../assets/icons/${this.$route.params.data.mainFeatures[0].type}-white.png`);
                } else {
                    return '';
                }
            },
            getExpectedModels() {
                return true;
            },
            getKeyFeatures() {
                if (typeof this.$route.params.data !== 'undefined') {
                    const firstArray = this.keyfeatures[this.$route.params.data.mainFeatures[0].id];
                    let temp = [];
                    const items = this.$route.params.data.mainFeatures.length;
                    if (items === 1) {
                        return firstArray;
                    } else if (items === 2) {
                        let secondArray = this.keyfeatures[this.$route.params.data.mainFeatures[1].id];

                        firstArray.map((item, index) => {
                            if (index < 4) {
                            return temp.push(item);
                        }
                    });
                        secondArray.map((item, index) => {
                            if (temp.length < 7 && !temp.includes(item)) {
                            return temp.push(item);
                        }
                    });
                        return temp;
                    } else if (items === 3) {
                        let secondArray = this.keyfeatures[this.$route.params.data.mainFeatures[1].id];
                        let thirdArray = this.keyfeatures[this.$route.params.data.mainFeatures[2].id];
                        firstArray.map((item, index) => {
                            if (index < 4) {
                            return temp.push(item);
                        }
                    });
                        secondArray.map((item, index) => {
                            if (temp.length < 6 && !temp.includes(item)) {
                            return temp.push(item);
                        }
                    });
                        thirdArray.map((item, index) => {
                            if (temp.length < 7 && !temp.includes(item)) {
                            return temp.push(item);
                        }
                    });
                        return temp;
                    }
                }
            },
            vehicleMapping() {
                if (this.$route.params.data) {
                    const price = this.$route.params.data.priceSelected;
                    const carType = this.$route.params.data.carSelected;
                    const decider = price + '' + carType;
                    if (decider === '00') return ['citigo_active', 'fabia_active', 'citigo_ambition', 'fabia_ambition'];
                    if (decider === '01') return ['octavia_active', 'rapid_active', 'octavia_ambition', 'rapid_ambition'];
                    if (decider === '02') return ['fabia_active', null, 'fabia_ambition', null];
                    if (decider === '03') return [null, null, null, null];

                    if (decider === '10') return ['fabia_mc', null, 'rapid_style', null];
                    if (decider === '11') return ['octavia_ambition', 'rapid_ambition', 'octavia_style', 'rapid_style'];
                    if (decider === '12') return ['fabia_combi_ambition', 'octavia_combi_ambition', 'fabia_combi_style', null];
                    if (decider === '13') return ['karoq_active', null, 'karoq_ambition', null];

                    if (decider === '20') return [null, null, null, null];
                    if (decider === '21') return ['octavia_rs_style', 'superb_style', 'octavia_rs_lk', 'superb_lk'];
                    if (decider === '22') return ['octavia_combi_style', 'superb_combi_style', 'octavia_combi_lk', 'superb_combi_lk'];
                    if (decider === '23') return ['karoq_style', 'kodiaq_style', 'karoq_lk', 'kodiaq_lk'];
                }
                return [null, null, null, null];
            },

            getCar(index) {
                if (this.vehicles[this.vehicleMapping()[index]]) {
                    return this.vehicles[this.vehicleMapping()[index]];
                } else {
                    return '-';
                }
            }
        },
        data() {
            return {
                type: {
                    economists: {
                        headline: 'Economists',
                        mainDescription: 'Value for money, bonuses, discounts, extra trim for free, family car, quality',
                        description: 'Loyal to brands and products, which they are satisfied with. Sales and discount oriented. When they are choosing a new car, safety and reliability is important for them.',
                    },
                    stylists: {
                        headline: 'Stylists',
                        mainDescription: 'Moder design, taste, elegance, harmony, craftmanship, detail, class',
                        description: 'Appearence is important as well as design quality craftmanship of things that surround them. They seed modern and elegant design cars.',
                    },
                    experts: {
                        headline: 'Experts',
                        mainDescription: 'Exclusivity, pride, recognition, attention seekers',
                        description: 'Customers prefer premium products, throught which they shor their status. They like to be in the center of attention. They are demanding. They respond positively to discount or bonus.',
                    },
                    practitioners: {
                        headline: 'Practitioners',
                        mainDescription: 'Value for money, funcionality, bonuse, extra trim for free, family car, quality',
                        description: 'Loyal customers, who knows car features needs and they are ready to pay for it. They like discounts and bonuses. Safety and reliability is important.',
                    },
                    racers: {
                        headline: 'Racers',
                        mainDescription: 'Power, fun, adrenalin, speed, overtaking, pleasure to drive, emotions',
                        description: 'Customers seek for the best solution. They like fast tempo of living and attention. They are fearless and emotional.',
                    },
                    guardians: {
                        headline: 'Guardians',
                        mainDescription: 'Safety, reliability, assistance, pride',
                        description: 'Customers seek reliable car with car assistance systems. They are focused on safe driving and they are careful. \n' +
                        'Customers are willing to pay for extra equipment with safety features.',
                    },
                },
                models: {},
                keyfeatures: {
                    'aquistition': [
                        'Total Discount',
                        'Discount Mats',
                        'Voucher for Oil Change Service',
                        'Free Tire Storage at the Service Station',
                        'Free Winter Tires',
                        'Depending on the current offer of discount on the market',
                        'Depending on the current offer of discount on the market',
                    ],
                    'operating_cost': [
                        'Total Discount',
                        'Discount Mats',
                        'Voucher for Oil Change Service',
                        'Free Tire Storage at the Service Station',
                        'Free Winter Tires',
                        'Depending on the current offer of discount on the market',
                        'Depending on the current offer of discount on the market',
                    ],
                    'best_price': [
                        'Total Discount',
                        'Discount Mats',
                        'Voucher for Oil Change Service',
                        'Free Tire Storage at the Service Station',
                        'Free Winter Tires',
                        'Depending on the current offer of discount on the market',
                        'Depending on the current offer of discount on the market',
                    ],
                    'exterior': [
                        'Panoramic Roof',
                        'Infotainment Glass Touchscreen',
                        'Leather Ventilated Seats',
                        'Adaptive Cruise Control and Lane Assist',
                        'Full-LED Lighting Technology',
                        'Wide Selection of Alloy Wheels',
                        'Ambient LED backlight for the Interior',
                    ],
                    'interior': [
                        'Panoramic Roof',
                        'Infotainment Glass Touchscreen',
                        'Leather Ventilated Seats',
                        'Adaptive Cruise Control and Lane Assist',
                        'Full-LED Lighting Technology',
                        'Wide Selection of Alloy Wheels',
                        'Ambient LED backlight for the Interior',
                    ],
                    'new_tech': [
                        'Automatic Parking Assistant',
                        'Heated Steering Wheel and Windscreen',
                        'Adaptive Frontlight System',
                        'Adjustable chassis',
                        'Emergency Break Assist',
                        'Progressive Power Steering',
                        'Heated Front and Rear Seats',
                    ],
                    'driving-characteristic': [
                        'Automatic Parking Assistant',
                        'Heated Steering Wheel and Windscreen',
                        'Adaptive Frontlight System',
                        'Adjustable chassis',
                        'Emergency Break Assist',
                        'Progressive Power Steering',
                        'Heated Front and Rear Seats',
                    ],
                    'luxury': [
                        'Automatic Parking Assistant',
                        'Heated Steering Wheel and Windscreen',
                        'Adaptive Frontlight System',
                        'Adjustable chassis',
                        'Emergency Break Assist',
                        'Progressive Power Steering',
                        'Heated Front and Rear Seats',
                    ],
                    'spacious': [
                        'Large luggage compartment with variable floor',
                        'Triple Self-Confirming Rear Seats',
                        'Car Trunk Cargo Net Mesh Storage Organizer',
                        'Active lifestyle accessories (eg. bike carriers, ski holders, ski box)',
                        '4x4',
                        'Cruise Control and Speed Limiter',
                        'Isofix Safety Belt Mounts With Belt',
                    ],
                    'engine': [
                        'Powerful motors (torque)',
                        '4x4',
                        'Off-road mode',
                        'Sports Seats',
                        'Advanced Information and Entertainment Systems',
                        'Interior Equipment Colors Offer ',
                        'LED Daytime Running Light',
                    ],
                    'safety': [
                        'Emergency Break Assist (precrash)',
                        'Up to 9 airbags',
                        'Blind Spot Detection',
                        'Lane Assist - Advanced Lane Departure Warning System',
                        'A System to Reduce the Risk of a Crisis Situation Caused by Driver Fatigue',
                        '230 V Socket and 2 USB Sockets on the Rear of the Car',
                        'Electric Child Safety Lock',
                    ]
                },
                vehicles: {
                    'citigo_active': '<strong>CitiGo</strong><br>Active',
                    'fabia_active': '<strong>Fabia</strong><br>Active',
                    'octavia_active': '<strong>Octavia</strong><br>Active',
                    'rapid_active': '<strong>Rapid</strong><br>Active',
                    'karoq_active': '<strong>Karoq</strong><br>Active',

                    'citigo_ambition': '<strong>CitiGo</strong><br>Ambition',
                    'fabia_ambition': '<strong>Fabia</strong><br>Ambition',
                    'octavia_ambition': '<strong>Octavia</strong><br>Ambition',
                    'rapid_ambition': '<strong>Rapid</strong><br>Ambition',
                    'fabia_combi_ambition': '<strong>Fabia Combi</strong><br>Ambition',
                    'octavia_combi_ambition': '<strong>Octavia Combi</strong><br>Ambition',
                    'karoq_ambition': '<strong>Karoq</strong><br>Ambition',

                    'fabia_mc': '<strong>Fabia</strong><br>Monte Carlo',

                    'rapid_style': '<strong>Rapid</strong><br>Style',
                    'octavia_style': '<strong>Octavia</strong><br>Style',
                    'fabia_combi_style': '<strong>Fabia Combi</strong><br>Style',
                    'octavia_rs_style': '<strong>Octavia RS</strong><br>Style',
                    'octavia_combi_style': '<strong>Octavia Combi</strong><br>Style',
                    'superb_style': '<strong>Superb</strong><br>Style',
                    'superb_combi_style': '<strong>Superb Combi</strong><br>Style',
                    'karoq_style': '<strong>Karoq</strong><br>Style',
                    'kodiaq_style': '<strong>Kodiaq</strong><br>Style',

                    'octavia_rs_lk': '<strong>Octavia RS</strong><br>L&amp;K',
                    'superb_lk': '<strong>Superb</strong><br>L&amp;K',
                    'karoq_lk': '<strong>Karoq</strong><br>L&amp;K',
                    'kodiaq_lk': '<strong>Kodiaq</strong><br>L&amp;K',
                    'octavia_combi_lk': '<strong>Octavia Combi</strong><br>L&amp;K',
                    'superb_combi_lk': '<strong>Superb Combi</strong><br>L&amp;K',
                    'karoq_combi_lk': '<strong>Karoq Combi</strong><br>L&amp;K',
                    'kodiaq_combi_lk': '<strong>Kodiaq Combi</strong><br>L&amp;K',
                },
            };
        },
    };
</script>